import * as React from 'react';

/**
 * To active the animation need to initial the AOS on the page inside componentDidMount of useEffect hook
 * ex: AOS.init() 
 */

interface AnimationWrapperProps{
    HtmlTag: 'div' | 'h1' | 'h2' | 'p' | 'section',
    children?: React.ReactNode,
    exClass?: string,
    aosAnimation?:{
        'data-aos'?: 'fade-up' | 'fade-down' | 'fade-right' | 'fade-left' | 'zoom-in' | 'zoom-out' | 'slide-up' | 'flip-up' | 'flip-down' | 'flip-right' | 'flip-left' | 'no',
        'data-aos-easing'?: 'linear' | 'ease' | 'ease-in' | 'ease-out' | 'ease-in-out' | 'ease-in-back' | 'ease-out-back' | 'ease-in-out-back' | 'ease-in-sine' | 'ease-out-sine' | 'ease-in-out-sine' | 'ease-in-out-quart',
        'data-aos-anchor-placement'?: 'top-bottom' | 'top-center' | 'top-top' | 'center-bottom' | 'center-center' | 'center-top' | 'bottom-bottom' | 'bottom-center' | 'bottom-top',
        'data-aos-offset'?: number,
        'data-aos-duration'?: number,        
        'data-aos-delay'?: number,
        'data-aos-anchor'?: string,        
        'data-aos-once'?: boolean,
        'data-aos-mirror'?: boolean,
    }
}


const AnimationWrapper:React.FC<AnimationWrapperProps> = (props) => {
    const {HtmlTag, children, exClass = '', aosAnimation = ''} = props;

    
    const T = `${HtmlTag}` as keyof JSX.IntrinsicElements;
    return (       
            <T className={exClass} {...aosAnimation}>
                {children}
            </T>        
    );
};

export { AnimationWrapperProps, AnimationWrapper };







